import { isDateISO } from 'src/helper/isDateISO'
import { contactServices } from 'src/services/reservation/contact/contact.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
export const handleUpdateContact = async (
  record: any,
  cardId: string,
  setLoadingContactModal: React.Dispatch<React.SetStateAction<boolean>>,
  setOpenContactModal: React.Dispatch<React.SetStateAction<boolean>>,
  notify: any,
  refresh: any,
  setCardLoading: any
) => {
  try {
    setLoadingContactModal(true)
    if (record && record?.contact) {
      const { contact } = record
      let date = contact?.birthday
      if (isDateISO(date)) {
        date = new Date(date).toISOString().split('T')?.[0]
      }
      const response = await contactServices.updateById(contact.id, { ...contact, birthday: date })
      if (response) {
        notify('ra.notification.updated_success_contact', {
          type: 'success',
          messageArgs: { contact: contact?.name },
        })
        return
      }
    }
    notify('ra.notification.updated_error_contact', {
      type: 'error',
    })
  } catch (error) {
    notify('ra.notification.updated_error_contact', {
      type: 'error',
    })
  } finally {
    setLoadingContactModal(false)
    setOpenContactModal(false)
    setCardLoading(cardId, true)
    customAwait([refresh])
  }
}
